import React, { useEffect, useRef } from "react";
import mapboxgl from "mapbox-gl";
import "mapbox-gl/dist/mapbox-gl.css";

mapboxgl.accessToken = process.env.REACT_APP_MAPBOX_TOKEN;

export default function MapTest() {
  const mapRef = useRef(null);

  useEffect(() => {
    if (!mapboxgl.accessToken) {
      console.error("❌ Mapbox token not loaded");
      return;
    }

    const map = new mapboxgl.Map({
      container: mapRef.current,
      style: "mapbox://styles/mapbox/streets-v12",
      center: [-7.5898, 33.5731], // Casablanca
      zoom: 12,
    });

    return () => map.remove();
  }, []);

  return (
    <div
      ref={mapRef}
      style={{ width: "100%", height: "100vh" }}
    />
  );
}
